;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesList = View.TippingLeaguesList.extend({
		template: JST.ExtendTippingLeaguesListForAflClubs,

		initData: function() {

			this.leagues.setCommissioner(this.user.get('id'))
				.setLeaguesAvatars()
				.setStatus()
				.setDecimals(1);

			this.rounds.invoke('set', { 'selected': false });

			this.round_id = this.rounds.getLastGameRound().get('id');

			if (!_.isNumber(this.round_id)) {
				this.round_id = 1;
			}

			this.rounds.get(this.round_id).set({'selected': true});

			return this;
		},
	});

}(window, APP, Backbone, Marionette, $, _));